module.exports = {"152202001":"阿尔山市林海街道","152202002":"阿尔山市新城街道","152202003":"阿尔山市温泉街道","152202004":"伊尔施街道","152202100":"阿尔山市天池镇","152202101":"阿尔山市白狼镇","152202102":"阿尔山市五岔沟镇","152202103":"明水河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152202.json
// module id = 478
// module chunks = 0